import React from "react";
import Dialog from "components/Dialog";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";
import { keepNumbersText } from "./format";
import { TPreview } from "./types";

const cn = classNames.bind(styles);

interface ISaveDialog {
  preview: TPreview;
  busy?: boolean;
  onUpdateThose: () => void;
  onLeaveThem: () => void;
}

/**
 * Shown only when saving would leave hand-changed meals as they are.
 * Rendered only while open (the shared Dialog just hides its children with CSS).
 */
const SaveDialog: React.FC<ISaveDialog> = ({
  preview,
  busy,
  onUpdateThose,
  onLeaveThem,
}) => (
  <Dialog isOpen>
    <div className={cn("dlg")} role="dialog" aria-modal="true">
      <h2>One thing to check</h2>
      <p>{keepNumbersText(preview.daysToUpdate, preview.changedMeals)}</p>
      <div className={cn("dlg-actions")}>
        <button
          type="button"
          className={cn("btn", "btn_primary")}
          disabled={busy}
          onClick={onUpdateThose}
        >
          Update those too
        </button>
        <button
          type="button"
          className={cn("btn")}
          disabled={busy}
          onClick={onLeaveThem}
        >
          Leave them
        </button>
      </div>
    </div>
  </Dialog>
);

export default SaveDialog;
